import React from "react";
import { FormFieldLabel, FormHelperText } from "./FormField";

interface TextAreaProps extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  type: string;
  placeholder: string;
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  fullWidth?: boolean;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  labelClassName?: string;
  error?: boolean;
  helperText?: string;
  className?: string;
  textAreaRef?: React.Ref<HTMLTextAreaElement>; // input ref, like for auto focus on mount
  required?: boolean;
  optional?: boolean;
  rows?: number;
}

const TextArea: React.FC<TextAreaProps> = ({
  name,
  type,
  placeholder,
  label = "",
  value,
  onChange,
  fullWidth = false,
  startAdornment,
  endAdornment,
  labelClassName,
  error,
  helperText,
  className,
  textAreaRef,
  required = false,
  optional = false,
  rows = 4,
  ...props
}) => {
  return (
    <div
      className={`flex flex-col ${className} ${fullWidth ? "w-full" : "w-fit"}`}
    >
      <FormFieldLabel
        label={label}
        required={required}
        optional={optional}
        className={labelClassName}
      />

      <div
        className={`bg-white flex items-center border border-gray-300 rounded-md overflow-hidden focus-within:border-[var(--app-primary)] ${
          fullWidth ? "w-full" : "w-fit"
        }`}
      >
        {startAdornment && (
          <div className="flex items-center gap-2 pl-1 text-gray-400">
            {startAdornment}
          </div>
        )}
        <textarea
          ref={textAreaRef}
          placeholder={placeholder}
          className={`p-2 text-sm focus:outline-none focus:ring-2 focus:ring-transparent placeholder:text-gray-400 placeholder:text-sm ${
            fullWidth ? "w-full" : "w-fit"
          }`}
          name={name}
          value={value}
          onChange={onChange}
          rows={rows}
          {...props}
        />
        {endAdornment && (
          <div className="flex items-center gap-2 pr-1 text-gray-400">
            {endAdornment}
          </div>
        )}
      </div>

      <FormHelperText helperText={helperText} error={error} />
    </div>
  );
};

export default TextArea;
